/**
 * Auth User Reducers
 */
import { SET_ADDRESS_LIST, SET_CONFIG, SET_CONFIG_RECRUITMENT, SET_DEFAULT_FIELD, SET_ALL_FIELD_LIST } from 'Actions/types';

/**
 * Initial Config
 */
const INIT_STATE = {
  addressList: null,
  staffList: [],
  fieldList: [],
  materialCategory: null,
  recruitment: null,
  allFieldList: [],
  defaultField: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_ADDRESS_LIST:
      return { ...state, addressList: action.payload };

    case SET_CONFIG:
      return { ...state, ...action.payload };

    case SET_CONFIG_RECRUITMENT:
      return { ...state, recruitment: action.payload };

    case SET_ALL_FIELD_LIST:
      return { ...state, allFieldList: action.payload };

    case SET_DEFAULT_FIELD:
      return { ...state, defaultField: action.payload };

    default:
      return { ...state };
  }
};
